export const isStandaloneApp = (browserWindow = typeof window === "undefined" ? null : window) => {
  try {
    return browserWindow?.navigator?.standalone === true ||
      ["standalone", "fullscreen"].some(mode => browserWindow?.matchMedia?.(`(display-mode: ${mode})`)?.matches === true);
  } catch (_) {
    return false;
  }
};
